const routerList = [
    {
        path: "/agent-merchant/settlement-overview",
        name: "结算概览",
        component: () => import("@/views/agent-merchant/settlement-overview/settlement-overview.vue"),
        children: [
            {
                path: "/agent-merchant/settlement-overview/details",
                name: "商户结算概况",
                component: () => import("@/views/agent-merchant/settlement-overview/children/details/details.vue"),
                meta: {
                    nameKey: "settlementOverviewDetails",
                },
            },
        ],
    },
    {
        path: "/agent-merchant/merchant-report",
        name: "商户报表",
        component: () => import("@/views/agent-merchant/merchant-report/merchant-report.vue"),
    },
];
export default routerList;
